import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { updateNumberColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getUpdateNumber } from "../../../../api/sim";

const COPY_KEYS = ["id", "msisdn", "status", "webhook", "created_at", "last_updated"];

const VSUpdateNumberBatch = () => (
  <BatchDetail
    title="Update Number"
    apiGet={__getUpdateNumber}
    client={CLIENTS.vs}
    columnsFactory={(ctx) => updateNumberColumns({ ...ctx, showPlan: false, showWebhook: true })}
    copyKeys={COPY_KEYS}
    exportAction="update_number"
    retryOperation="update_number"
    showTerminate
    getRowPath={(row) => `/vs/update_number/${row.id}`}
  />
);

export default VSUpdateNumberBatch;
